export enum EnumCampaignStatus {
  Scheduled = 0,
  Running = 1,
  Archived = 2,
  Paused = 3,
  Holding = 4,
}
